"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jspdf_1 = require("jspdf");
const dayjs_1 = __importDefault(require("../../../shared/lib/dayjs"));
const currency_1 = require("../../../shared/utils/currency");
const abcRepository_1 = __importDefault(require("../../infraestructure/repositories/abcRepository"));
async function generateAmortizationTableInPdf(abc, distributor, insurer, enganche, price, plazo) {
    const dealer = await (0, abcRepository_1.default)().findDealerBySubsidiary(distributor.caption_text);
    const docPdf = new jspdf_1.jsPDF({
        format: "letter",
    });
    const yearCost = insurer.MULTIRECIBOS[0].PRIMA_TOTAL;
    const financedAmount = (0, currency_1.parseToMexicanPeso)(price + insurer.PRIMA_TOTAL - abc.quotation.Anticipo);
    const valueAddedTax = (0, currency_1.parseToMexicanPeso)((abc.data.Commission + enganche) * 0.16);
    const lessAdvancePayment = (0, currency_1.parseToMexicanPeso)(enganche * 1.16);
    const administrationCosts = (0, currency_1.parseToMexicanPeso)(abc.data.Rent * 0.1);
    const totalInitialPayment = (0, currency_1.parseToMexicanPeso)((abc.data.Commission + enganche) * 0.16 + abc.data.Commission + abc.quotation.Anticipo);
    const paymentForInsurance = (0, currency_1.parseToMexicanPeso)((insurer.PRIMA_TOTAL - yearCost) / plazo);
    const totalMonthlyPayment = (0, currency_1.parseToMexicanPeso)(abc.data.Rent + abc.data.Rent * 0.1 + (insurer.PRIMA_TOTAL - yearCost) / plazo);
    docPdf.setTextColor(0, 0, 0);
    docPdf.setFontSize(16);
    docPdf.text("HYUNDAI FINANCE", 10, 20);
    docPdf.setFontSize(13);
    docPdf.text("Cotización de Arrendamiento", 136, 23);
    docPdf.setFontSize(9);
    docPdf.text("Folio: HYUNDAI2023216317037", 149, 26);
    //ACTUALIZAR FECHA
    docPdf.setFontSize(8);
    docPdf.text(`Mérida, Yucatán a ${(0, dayjs_1.default)().format("DD/MM/YYYY")}`, 157, 30);
    //ACTUALIZAR FOLIO
    docPdf.setFontSize(8);
    docPdf.text("Folio del seguro: 42584751", 10, 30);
    docPdf.setFontSize(8);
    docPdf.text("Nombre del proovedor: " + dealer.name, 10, 40);
    docPdf.setFontSize(8);
    docPdf.text("Telefono: " + dealer.phone, 10, 44);
    docPdf.setFontSize(8);
    docPdf.text("Dirección: " + dealer.address, 10, 48);
    //NEW SECTION
    docPdf.setTextColor(20, 62, 158);
    docPdf.setFontSize(10);
    docPdf.setFont("", "bold").text("Conceptos Financiados incluye IVA", 10, 60);
    docPdf.setFont("", "bold").text(`${plazo} Meses`, 100, 60);
    docPdf.setFillColor(20, 62, 158);
    docPdf.rect(10, 61, 200, 1, "F");
    docPdf.setFillColor(236, 223, 220);
    docPdf.rect(10, 64, 200, 6, "F");
    docPdf.setTextColor(0, 0, 0);
    docPdf.setFontSize(8);
    docPdf.setFont("", "normal").text("Valor de la Unidad", 12, 68);
    docPdf.text(`${(0, currency_1.parseToMexicanPeso)(price)}`, 100, 68);
    docPdf.setFillColor(249, 242, 240);
    docPdf.rect(10, 70, 200, 6, "F");
    docPdf.text("Seguro Financiado", 12, 75);
    docPdf.text(`${(0, currency_1.parseToMexicanPeso)(insurer.PRIMA_TOTAL)}`, 100, 75);
    docPdf.setFillColor(236, 223, 220);
    docPdf.rect(10, 76, 200, 6, "F");
    docPdf.text("(-menos) Anticipo", 12, 80);
    docPdf.text(lessAdvancePayment, 100, 80);
    docPdf.setFillColor(249, 242, 240);
    docPdf.rect(10, 82, 200, 6, "F");
    docPdf.setFont("", "bold").text("Monto Total Financiado", 12, 86);
    docPdf.text(`${financedAmount}`, 100, 86);
    // END SECTION
    //NEW SECTION
    docPdf.setTextColor(20, 62, 158);
    docPdf.setFontSize(10);
    docPdf.setFont("", "bold").text("Pago Inicial", 10, 95);
    docPdf.setFillColor(20, 62, 158);
    docPdf.rect(10, 96, 200, 1, "F");
    docPdf.setFillColor(236, 223, 220);
    docPdf.rect(10, 98, 200, 6, "F");
    docPdf.setTextColor(0, 0, 0);
    docPdf.setFontSize(8);
    docPdf.setFont("", "normal").text("Anticipo", 12, 102);
    docPdf.text(`${(0, currency_1.parseToMexicanPeso)(abc.quotation.Anticipo)}`, 100, 102);
    docPdf.setFillColor(249, 242, 240);
    docPdf.rect(10, 104, 200, 6, "F");
    docPdf.text("Seguro primer año", 12, 107);
    docPdf.text("Financiado", 100, 107);
    docPdf.setFillColor(236, 223, 220);
    docPdf.rect(10, 110, 200, 6, "F");
    docPdf.setTextColor(0, 0, 0);
    docPdf.setFontSize(8);
    docPdf.setFont("", "normal").text("Comisión por apertura", 12, 113);
    docPdf.text(`${(0, currency_1.parseToMexicanPeso)(abc.data.Commission)}`, 100, 113);
    docPdf.setFillColor(249, 242, 240);
    docPdf.rect(10, 116, 200, 6, "F");
    docPdf.text("Subtotal Pago inicial", 12, 119);
    docPdf.text(`${(0, currency_1.parseToMexicanPeso)(abc.data.Commission + abc.quotation.Anticipo)}`, 100, 119);
    docPdf.setFillColor(236, 223, 220);
    docPdf.rect(10, 122, 200, 6, "F");
    docPdf.setTextColor(0, 0, 0);
    docPdf.setFontSize(8);
    docPdf.setFont("", "normal").text("Impuesto al Valor Agregado", 12, 125);
    docPdf.text(valueAddedTax, 100, 125);
    docPdf.setFillColor(249, 242, 240);
    docPdf.rect(10, 128, 200, 6, "F");
    docPdf.setFont("", "bold").text("Total Pago Inicial", 12, 131);
    docPdf.text(totalInitialPayment, 100, 131);
    // END SECTION
    //NEW SECTION
    docPdf.setTextColor(20, 62, 158);
    docPdf.setFontSize(10);
    docPdf.setFont("", "bold").text("Renta Mensual (no incluye IVA)", 10, 140);
    docPdf.setFillColor(20, 62, 158);
    docPdf.rect(10, 141, 200, 1, "F");
    docPdf.setFillColor(236, 223, 220);
    docPdf.rect(10, 142, 200, 6, "F");
    docPdf.setTextColor(0, 0, 0);
    docPdf.setFontSize(8);
    docPdf.setFont("", "normal").text("Renta básica", 12, 146);
    docPdf.text(`${(0, currency_1.parseToMexicanPeso)(abc.data.Rent)}`, 100, 146);
    docPdf.setFillColor(249, 242, 240);
    docPdf.rect(10, 148, 200, 6, "F");
    docPdf.text("Gastos administración", 12, 153);
    docPdf.text(administrationCosts, 100, 153);
    docPdf.setFillColor(236, 223, 220);
    docPdf.rect(10, 154, 200, 6, "F");
    docPdf.text("Pago por seguro", 12, 158);
    docPdf.text(paymentForInsurance, 100, 158);
    docPdf.setFillColor(249, 242, 240);
    docPdf.rect(10, 160, 200, 6, "F");
    docPdf.setFont("", "bold").text("Total Pago Mensual", 12, 164);
    docPdf.text(totalMonthlyPayment, 100, 164);
    // END SECTION
    //NEW SECTION
    docPdf.setTextColor(20, 62, 158);
    docPdf.setFontSize(10);
    docPdf.setFont("", "bold").text("Valor Residual (no incluye IVA)", 10, 173);
    docPdf.setFillColor(20, 62, 158);
    docPdf.rect(10, 174, 200, 1, "F");
    docPdf.setFillColor(249, 242, 240);
    docPdf.rect(10, 176, 200, 6, "F");
    docPdf.setTextColor(0, 0, 0);
    docPdf.setFont("", "bold").text("Valor Residual", 12, 180);
    docPdf.text(`${(0, currency_1.parseToMexicanPeso)(abc.data.ResidualValue)}`, 100, 180);
    // END SECTION
    docPdf.rect(95, 55, 30, 133);
    docPdf.setFillColor(51, 64, 71);
    docPdf.rect(0, 220, 300, 100, "F");
    docPdf.setTextColor(255, 255, 255);
    docPdf
        .setFont("", "normal")
        .setFontSize(6)
        .text(`1. La presente cotización estará vigente hasta el ${(0, dayjs_1.default)().format("DD/MM/YYYY")}`, 15, 226);
    docPdf.text("2. El pago inicial no incluye impuestos locales como tenencia, costo de placas y gastos de gestoría, los importes originados por estos conceptos serán cargados", 15, 229);
    docPdf.text("a la cuenta domiciliada una vez que se hayan realizado los trámites correspondientes.", 15, 231);
    docPdf.text("3. Recuerde que, en automóviles utilitarios el límite de deducibilidad mensual establecido por la Ley de Impuesto Sobre la Renta es de $6,000.00 mensuales", 15, 234);
    docPdf.text("(sin incluir IVA ni gastos de arrendamiento). Este límite no aplica para vehículos de trabajo tales como pickups y camiones de carga ligera.", 15, 236);
    docPdf.text("4. Cualquier cambio respecto a las condiciones establecidas dentro del proceso de aprobación de crédito correspondiente invalida la presente propuesta, misma que", 15, 239);
    docPdf.text("únicamente será posible ejercer durante su vigencia.", 15, 241);
    docPdf.text("5. Nota importante: Bajo la opción de pago de la prima de seguro anual de contado, es posible que las anualidades siguientes puedan sufrir incrementos,", 15, 244);
    docPdf.text("dependiendo de la siniestralidad del vehículo o por cambios en las políticas de precio de la aseguradora, por lo que bajo esta modalidad se acepta", 15, 246);
    docPdf.text("6. El límite de kilometraje es de manera anual, si el usuario excede la cantidad de kilómetros establecidos, no existirá ningún costo siempre y cuando", 15, 250);
    docPdf.text("se pague el valor residual, de lo contrario cada KM extra tendrá un costo.", 15, 252);
    docPdf.text("7. Esta cotización está sujeta a cambios sin previo aviso hasta la aceptación y firma del contrato.", 15, 256);
    docPdf.text("Calle 56-B No. 452 x 11 y 13", 10, 265);
    docPdf.text("Colonia Itzimná", 10, 268);
    docPdf.text("Mérida, Yucatán C.P. 97100", 10, 271);
    docPdf.text("(999) 940 6778, (999) 940 6779", 10, 274);
    return docPdf;
}
exports.default = generateAmortizationTableInPdf;
